import { styled } from '@material-ui/core/styles';

// --shared-header-height is set dynamically by the provider's header script
// via ResizeObserver after mount (same convention as boutique/CMS2). The
// fallback px value is only used before the script has loaded/mounted.
const getPaddingTop = (isDesktop: boolean, isLoginPage: boolean) => {
  if (isLoginPage) return 0;
  return `var(--shared-header-height, ${isDesktop ? '90px' : '80px'})`;
};

export const StyledContainer = styled('div')(
  ({
    isDesktop,
    isLoginPage,
  }: {
    isDesktop: boolean;
    isLoginPage: boolean;
  }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    paddingTop: getPaddingTop(isDesktop, isLoginPage),
  }),
);
